/**
 * integratr.ts - Integratr (API Integration) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const integratrModule = {
  id: 'integration-integratr',
  name: 'API Integration',
  icon: '🔌',
  category: 'modules',
  order: 40,
  
  packageInfo: {
    name: '@opcentral/integratr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'External API integration and webhook management for OpCentral',
    status: 'in-progress',
    implementationProgress: 60,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      '@opcentral/loggr': '*'
    },
    keywords: ['integration', 'api', 'webhook', 'external'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableWebhooks: {
      type: 'boolean',
      label: 'Enable Webhooks',
      description: 'Allow webhook integrations',
      defaultValue: true
    },
    
    webhookTimeout: {
      type: 'number',
      label: 'Webhook Timeout (seconds)',
      description: 'Maximum time to wait for webhook response',
      defaultValue: 30,
      min: 5,
      max: 120,
      visible: (settings) => settings['integration-integratr.enableWebhooks']
    },
    
    retryFailedRequests: {
      type: 'boolean',
      label: 'Retry Failed Requests',
      description: 'Automatically retry failed API calls',
      defaultValue: true
    },
    
    maxRetries: {
      type: 'number',
      label: 'Max Retries',
      description: 'Maximum number of retry attempts',
      defaultValue: 3,
      min: 1,
      max: 10,
      visible: (settings) => settings['integration-integratr.retryFailedRequests']
    }
  }
};

export default integratrModule;
